<script>
var basicInfoStep = {
  id: 'pkf_form_basic_info',
  title: 'Basic Info',
  icon: 'bx bx-info-circle',
  component: () => import('./reference-file'),
  active: false,
  validated: false
}

var cadInfoStep = {
  id: 'cad-info',
  title: 'Cad Info',
  icon: 'bx bx-ruler',
  component: () => import('./cad-info'),
  active: false,
  validated: false
}

var commentStep = {
  id: 'comments',
  title: 'Comments',
  icon: 'bx bx-comment',
  component: () => import('../shared/comments'),
  active: false,
  validated: false
}

var imageUploadStep = {
  id: 'image-upload',
  title: 'Aditional File Upload',
  icon: 'bx bxs-file-plus',
  component: () => import('./image-upload'),
  skip: true,
  active: false,
  validated: false
}

var shippingStep = {
  id: 'shipping',
  title: 'Delivery Information',
  icon: 'bx bx-package',
  component: () => import('../shared/shipping'),
  active: false,
  validated: false
}

var aluCasingStep = {
  id: 'aluCasing',
  title: 'Alumnium Casing',
  icon: 'bx bx-wrench',
  component: () => import('./alu-casing'),
  active: false,
  skip: true,
  validated: false
}

var remillStep = {
  id: 'remillStep',
  title: 'Find Previous Order',
  icon: 'bx bx-search-alt',
  component: () => import('./remill'),
  active: false,
  skip: true,
  validated: false
}

import { authComputed } from '@/state/helpers'

export default {
  name: 'custom-seat-form',
  props: {
    value: { type: Object, default: () => {} },
    submitLabel: { type: String, default: 'add to cart' },
    submitIcon: { type: String, default: 'bx bx-cart' }
  },

  data: vm => ({
    form: {
      customer_account_id: null,
      file_id: null,
      file_name: null,
      reference: '',
      not_found: false,
      item_id: null,
      images: [],
      specs: {
        model_type: null,
        other_model_type: null,
        foam_type: null,
        mix_seat_foam_type: null,
        mix_back_foam_type: null,
        offset_3d: 0,
        widen: 0,
        lengthen: 0,
        inclination: 'legs_horizontal',
        inclination_custom: 0,
        symmetrization: null,
        max_foam_width: 0,
        build_casing: false,
        add_head_support: false,
        add_foot_support: false,
        add_abduction: false,
        add_table_system: false,
        add_arm_support: false,
        head_support_foam_size: null,
        head_support_foam_model: null,
        foot_support_tube_length: null,
        foot_support_abs_plate: null,
        foot_support_footplates: null,
        can_use_glue: false,
        last_order_date: null,
        last_reference: '',
        is_remill: false,
        remill_webform_id: null,
        mattress_abduction_type: null
      },
      ...vm.value
    }
  }),

  watch: {
    'form.specs.model_type': {
      handler (val) {
        if (val !== 'full_seat') aluCasingStep.skip = true
        else aluCasingStep.skip = !this.userProfile.preferences.allow_alu_casing
      }
    },
    'form.specs.is_remill': {
      handler (val) {
        remillStep.skip = !val
      },
      immediate: true
    }
  },
  methods: {
    reset () {
      this.form = {
        specs: {
          model_type: null,
          other_model_type: null,
          foam_type: null,
          mix_seat_foam_type: null,
          mix_back_foam_type: null,
          offset_3d: 0,
          widen: 0,
          lengthen: 0,
          inclination: 'legs_horizontal',
          inclination_custom: 0,
          symmetrization: null,
          max_foam_width: 0,
          build_casing: false,
          add_head_support: false,
          add_foot_support: false,
          add_abduction: false,
          add_table_system: false,
          add_arm_support: false,
          can_use_glue: false,
          is_remill: false,
          not_found: false,
          last_order_date: null,
          last_reference: '',
          mattress_abduction_type: null
        },
        item_id: null,
        file_id: null,
        file_name: null,
        reference: '',
        is_remill: false,
        comments: '',
        images: []
      }
      this.$refs.wizard.reset()
    },
    onSaveHandler ($event, validate) {
      if (!validate || typeof validate !== 'function' || !validate()) return

      const wizardForm = this.$refs.wizard?.form || {}
      const customer_account_id =
        wizardForm.customer_account_id ||
        this.form.customer_account_id ||
        this.$store.state.auth.selectedCustomerAccountId

      if (this.needsCustomerStep && !customer_account_id) {
        this.$root.$bvToast.toast('Please select a customer.', {
          title: 'Customer required',
          solid: true,
          variant: 'danger',
          autoHideDelay: 3000,
          appendToast: true,
          toaster: 'b-toaster-top-center'
        })
        return
      }

      this.$emit('complete', {
        ...this.form,
        ...wizardForm,
        customer_account_id
      })
      this.reset()
    },
    onCancel () {
      this.reset()
      this.$nextTick(() => {
        this.$emit('cancel')
      })
    }
  },
  computed: {
    ...authComputed,
    steps () {
      imageUploadStep.skip = !this.userProfile.preferences.allow_image_upload

      let steps = [
        basicInfoStep,
        imageUploadStep,
        remillStep,
        cadInfoStep,
        aluCasingStep,
        commentStep,
        shippingStep
      ]

      if (this.needsCustomerStep) {
        steps = [
          {
            id: 'select_customer',
            title: 'Customer',
            icon: 'bx bx-user',
            component: () => import('../shared/select-customer'),
            active: true,
            validated: false
          },
          ...steps
        ]
      }

      steps.forEach((step, index) => {
        step.active = index === 0 && !step.skip
      })

      return steps
    }
  }
}
</script>
<template>
  <g-form-wizard
    v-if="needsCustomerStep || userProfile.id"
    :steps="steps"
    v-model="form"
    ref="wizard"
    :key="`wizard-${needsCustomerStep}`"
  >
    <template
      v-slot:buttons="{
        isFirstStep,
        isLastStep,
        nextStep,
        previousStep,
        validateStep
      }"
    >
      <div
        class="d-flex justify-content-between align-items-center border-top pt-2"
      >
        <b-btn variant="link" class="mr-2" v-on:click="onCancel">
          Cancel
        </b-btn>

        <div class="d-flex justify-content-end w-100">
          <b-btn
            variant="link"
            class="mr-2 d-flex align-items-center"
            v-on:click="previousStep"
            :disabled="isFirstStep"
          >
            <i class="bx bx-left-arrow mr-2"></i>Back
          </b-btn>

          <b-btn
            variant="primary"
            class="btn-label mr-2"
            v-on:click="onSaveHandler($event, validateStep)"
            v-if="isLastStep"
          >
            <i class="label-icon" :class="[submitIcon]"></i>
            {{ $t(submitLabel) }}
          </b-btn>
          <b-btn
            variant="primary"
            class="mr-2 d-flex align-items-center"
            v-on:click="nextStep"
            v-else
          >
            Next<i class="bx bx-right-arrow ml-2"></i>
          </b-btn>
        </div>
      </div>
    </template>
  </g-form-wizard>
</template>
